import { getRequest, postRequest, upLoadRequest } from './request'
/**
 * 思想政治
 **/

//图片上传
export const upLoad = data => {
    return upLoadRequest('/Api/Upload/image', data)
}
// 用户账户注册
export const register = data => {
    return postRequest('/Api/Member/register', data)
}
// 获取文章栏目  1 思想政治 2政策解读
export const getKinds = data => {
    return getRequest('/Api/Article/getChannelList', data)
}
// 获取文章列表
export const getArticle = data => {
    return getRequest('/Api/Article/query', data)
}
// 获取文章详情
export const getArticleDetails = data => {
    return getRequest('/Api/Article/detail', data)
}
// 获取推荐视频
export const getRemmendVideo = data => {
    return getRequest('/Api/Article/getRecommentList', data)
}

// 获取地区分类
export const getAreaKinds = data => {
    return getRequest('/Api/CategoryDistrict/query', data)
}

//获取分类数组
export const getKindArray = data => {
    return getRequest('/Api/Category/query', data)
}

// 获取期望职位分类列表

export const getPosition = data => {
    return getRequest('/Api/CategoryJob/query', data)
}

//用户端会员登录
export const memberLogin = data => {
    return postRequest('/Api/Member/login', data)
}

// 查询工作经历列表
export const queryWorkList = data => {
    return postRequest('/Api/ResumeWork/query', data)
}
// 查询教育经历列表
export const queryEductionList = data => {
    return postRequest('/Api/ResumeEducation/query', data)
}
// 面试详情
export const interviewDetail = data => {
    return postRequest('/Api/JobApply/interviewDetail', data)
}
// 面试取消
export const interviewCancel = data => {
    return postRequest('/Api/JobApply/interviewCancel', data)
}
//查询 求职意向列表
export const queryPositionList = data => {
    return postRequest('/Api/ResumeIntent/query', data)
}
// 查询个人优势
export const queryPersonalInfo = data => {
    return postRequest('/Api/Member/info', data)
}
// 修改个人优势
export const editInfo = data => {
    return postRequest('/Api/Resume/updateDescription', data)
}
//修改工作经历
export const editWork = data => {
    return postRequest('/Api/ResumeWork/update', data)
}
// 新增工作经历
export const addWork = data => {
    return postRequest('/Api/ResumeWork/commit', data)
}
// 查询工作经历详情
export const workDetails = data => {
    return postRequest('/Api/ResumeWork/detail', data)
}
// 删除工作经历
export const deleteWork = data => {
    return postRequest('/Api/ResumeWork/delete', data)
}
// 修改教育经历
export const editEduction = data => {
    return postRequest('/Api/ResumeEducation/update', data)
}
// 新增教育经历数据
export const addEduction = data => {
    return postRequest('/Api/ResumeEducation/commit', data)
}
// 查询教育经历详情
export const eductionDetails = data => {
    return postRequest('/Api/ResumeEducation/detail', data)
}
// 删除教育经历
export const deleteEduction = data => {
    return postRequest('/Api/ResumeEducation/delete', data)
}
// 修改求职意向数据
export const editPosition = data => {
    return postRequest('/Api/ResumeIntent/update', data)
}
// 修改求职状态
export const editPositionStatus = data => {
    return postRequest('/Api/Resume/updateApplyStatus', data)
}
// 新增求职意向
export const addPosition = data => {
    return postRequest('/Api/ResumeIntent/commit', data)
}
// 查询求职意向详情
export const positionDetails = data => {
    return postRequest('/Api/ResumeIntent/detail', data)
}
// 删除求职意向
export const detelePosition = data => {
    return postRequest('/Api/ResumeIntent/delete', data)
}

// 修改个人资料
export const editPerson = data => {
    return postRequest('/Api/Resume/edit', data)
}
// 查询个人资料
export const queryPreson = data => {
    return postRequest('/Api/Resume/detail', data)
}
// 获取活动列表
export const getActivtyList = data => {
    return postRequest('/Api/TrainActivity/query', data)
}
// 获取活动详情
export const getActiveDetails = data => {
    return postRequest('/Api/TrainActivity/detail', data)
}
// 参加活动
export const joinActive = data => {
    return postRequest('/Api/TrainActivity/join', data)
}
// 获取申请记录
export const getApplication = data => {
    return postRequest('/Api/TrainActivity/getApplyRecord', data)
}
// 获取职位列表
export const getPositionList = data => {
    return getRequest('/Api/Job/query', data)
}
// 获取职位详情
export const getPositionDetails = data => {
    return postRequest('/Api/Job/detail', data)
}
// 取消收藏
export const cancelCollect = data => {
    return postRequest('/Api/JobCollect/cancel', data)
}
// 职位收藏
export const confirmCollect = data => {
    return postRequest('/Api/Job/collect', data)
}
// 获取收藏职位
export const getCollectList = data => {
    return postRequest('/Api/JobCollect/query')
}
//获取企业详情
export const getCompanyDetails = data => {
    return getRequest('/Api/Company/detail', data)
}
// 首页轮播图
export const getBanner = data => {
    return getRequest('/Api/PositionContent/getIndexBanner', data)
}
// 浏览记录总数
export const getWatchNum = data => {
    return postRequest('/Api/JobBrowse/getTotal', data)
}
// 收藏总数
export const getCollectNum = data => {
    return postRequest('/Api/JobCollect/getTotal', data)
}
// 申请总数
export const getApplyNum = data => {
    return postRequest('/Api/JobApply/getApplyTotal', data)
}
// 职位申请
export const positionReply = data => {
    return postRequest('/Api/Job/apply', data)
}
// 待面试总数
export const getInterviewNum = data => {
    return postRequest('/Api/JobApply/getInterviewTotal', data)
}
// 浏览记录列表
export const getBrowseList = data => {
    return postRequest('/Api/JobBrowse/query', data)
}
// 面试记录列表
export const getInterviewList = data => {
    return postRequest('/Api/JobApply/interviewList', data)
}
// 申请记录列表
export const getApplyList = data => {
    return postRequest('/Api/JobApply/query', data)
}
// 上传头像
export const upLoaduserHead = data => {
    return postRequest('/Api/Resume/updateAvatar', data)
}
// 获取律师列表
export const lawyerList = data => {
    return getRequest('/Api/Lawyer/query', data)
}
// 获取消息列表
export const messageList = data => {
    return postRequest('/Api/LawyerMessage/query', data)
}
// 消息发送
export const sendMessage = data => {
    return postRequest('/Api/LawyerMessage/sendToLawyer', data)
}
// token验证
export const tokenCheck = data => {
    return postRequest('/Api/Member/checkToken', data)
}
// 获取民族
export const getNationData = data => {
    return getRequest('/Api/Public/getNationData', data)
}
// 获取政治面貌数据类型
export const getPoliticsStatusData = data => {
    return getRequest('/Api/Public/getPoliticsStatusData', data)
}
// 获取人员数据基本类型
export const getPersonnelTypeData = data => {
    return getRequest('/Api/Public/getPersonnelTypeData', data)
}
// 获取优抚类型数据

export const getSpecialCareData = data => {
    return getRequest('/Api/Public/getSpecialCareData', data)
}
// 退出登录

export const MemberLoginOut = data => {
    return postRequest('/Api/Member/logout', data)
}
// 获取求职状态
export const getResumeApplyStatus = data => {
    return postRequest('/Api/Public/getResumeApplyStatus', data)
}

/**
 * 企业注册
 * 
 * **/
export const companyRegister = data => {
    return postRequest('/Api/Company/register', data)

}

// 企业已发布职位
export const companyPositionList = data => {
    return postRequest('/Api/Job/submitList', data)
}
//发布职位
export const releasePosition = data => {
    return postRequest('/Api/Job/submit', data)
}
// 发布详情
export const releaseDetails = data => {
    return postRequest('/Api/Job/submitDetail', data)
}
// 职位删除
export const releaseDelete = data => {
    return postRequest('/Api/Job/delete', data)
}
// 职位关闭
export const releaseClose = data => {
    return postRequest('/Api/Job/close', data)
}
// 牛人推荐
export const tjList = data => {
    return postRequest('/Api/Resume/recommendList', data)
}
// 简历详情
export const resumeDetails = data => {
    return postRequest('/Api/Resume/recommendDetail', data)
}
// 拒绝面试
export const refuseInterview = data => {
    return postRequest('/Api/JobApply/refuse', data)
}
// 邀请面试
export const InvitationBtn = data => {
    return postRequest('/Api/JobApply/invite', data)
}
// 申请记录
export const applicationList = data => {
    return postRequest('/Api/JobApply/companyApplyList', data)
}
// 职位编辑
export const edit = data => {
    return postRequest('/Api/Job/edit', data)
}
// 申请详情
export const applyResumeDetail = data => {
    return postRequest('/Api/JobApply/applyResumeDetail', data)
}
// 取消面试
export const cancel = data => {
    return postRequest('/Api/JobApply/cancel', data)
}
// 面试完成
export const interviewCommit = data => {
    return postRequest('/Api/JobApply/interviewCommit', data)
}
// 登录退出
export const logout = data => {
    return postRequest('/Api/Company/logout', data)
}
// 获取企业账户信息
export const getCompanyDetail = data => {
    return postRequest('/Api/CompanyMember/getCompanyDetail', data)
}
// 修改企业账户信息
export const editCompanyInfo = data => {
    return postRequest('/Api/CompanyMember/editCompanyInfo', data)
}
// 位置开启
export const openPosition = data => {
    return postRequest('/Api/Job/open', data)
}
// 微信登录
export const wechatLogin = data => {
    return postRequest('/Api/Member/wechatLogin', data)
}
// 微信绑定
export const wechatBind = data => {
    return postRequest('/Api/Member/wechatBind', data)
}
// 微信解绑
export const wechatUnbind = data => {
    return postRequest('/Api/Member/wechatUnbind', data)
}
// 获取职位申请人数
export const companyApplyTotal = data => {
    return postRequest('/Api/JobApply/companyApplyTotal', data)
}
// 获取职位
export const submitTotal = data => {
    return postRequest('/Api/Job/submitTotal', data)
}
// 简历收藏
export const Resumecollect = data => {
    return postRequest('/Api/Resume/collect', data)
}
// 简历取消收藏  /Api/ResumeCollect/cancel
export const ResumeCollectCancel = data => {
    return postRequest('/Api/ResumeCollect/cancel', data)
}
// 获取企业列表
export const companyQuery = data => {
    return postRequest('/Api/Company/query', data)
}
// 获取受邀列表
export const JobInvite = data => {
    return postRequest('/Api/JobInvite/query', data)
}
// 简历邀请
export const remouseInvite = data => {
    return postRequest('/Api/Resume/invite', data)
}
// 邀请记录
export const inviteList = data => {
    return postRequest('/Api/Resume/inviteList', data)
}
// 已邀请数量
export const inviteTotal = data => {
    return postRequest('/Api/Resume/inviteTotal', data)
}
// 受邀请数量
export const getTotal = data => {
    return postRequest('/Api/JobInvite/getTotal', data)
}
// 获取 个人注册信息
export const getRegisterInfo = data => {
    return postRequest('/Api/Member/getRegisterInfo', data)
}
// 个人注册信息更新
export const updateRegisterInfo = data => {
    return postRequest('/Api/Member/updateRegisterInfo', data)
}

//获取 企业注册信息
export const companyGetRegister = data => {
    return postRequest('/Api/CompanyMember/getRegisterInfo', data)
}
// 企业注册信息更新  
export const companyUpdateRegisterInfo = data => {
    return postRequest('/Api/CompanyMember/updateRegisterInfo', data)
}
//获取微信sdk配置
export const wechatApi = data => {
    return postRequest('/Api/Common/getWxConfig', data)
}
//获取网站配置
export const commonConfig = data => {
    return postRequest('/Api/Common/config', data)
}
// 留言板
export const messageAdd = data => {
    return postRequest('/Api/Message/create', data)
}
// 天气
export const getWeatherByAdCode = data => {
    return getRequest('/Api/Amap/getWeatherByAdCode', data)
}
// 推荐位
export const positionContent = data => {
    return getRequest('/api/PositionContent/lists', data)
}